var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.169,
    height: 36.444,
    viewBox: "1255.832 349.001 40.169 36.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "71a4a2dbf0ec0e4b56f554d6cd9aaf40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1260.354 366.716a4.522 4.522 0 0 1 4.523 4.523v9.683a4.522 4.522 0 0 1-4.523 4.523 4.522 4.522 0 0 1-4.522-4.523v-9.683a4.522 4.522 0 0 1 4.522-4.523z",
    fill: "#ffcd3e",
    fillRule: "evenodd",
    "data-name": "Rectangle 23853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.73 357.247a4.522 4.522 0 0 1 4.522 4.523v19.152a4.522 4.522 0 1 1-9.045 0V361.77a4.522 4.522 0 0 1 4.522-4.523Z",
    fill: "#a1a3ef",
    fillRule: "evenodd",
    "data-name": "Path 93446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1281.103 361.902a4.522 4.522 0 0 1 4.522 4.523v14.497a4.522 4.522 0 0 1-4.522 4.523 4.522 4.522 0 0 1-4.523-4.523v-14.497a4.522 4.522 0 0 1 4.523-4.523z",
    fill: "#ffcd3e",
    fillRule: "evenodd",
    "data-name": "Rectangle 23855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1291.478 349a4.522 4.522 0 0 1 4.522 4.523v27.4a4.522 4.522 0 0 1-4.522 4.522 4.522 4.522 0 0 1-4.523-4.523v-27.399a4.522 4.522 0 0 1 4.523-4.522z",
    fill: "#a1a3ef",
    fillRule: "evenodd",
    "data-name": "Rectangle 23856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.338 380.64a1.157 1.157 0 0 1-.827-1.98l12.785-12.783a1.157 1.157 0 0 1 1.64 0l5.783 5.783 12.952-12.962a1.16 1.16 0 0 1 1.64 1.641l-13.776 13.776a1.157 1.157 0 0 1-1.64 0l-5.783-5.783-11.963 11.963a1.157 1.157 0 0 1-.811.345Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 93444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.266 366.966a1.157 1.157 0 0 1-1.157-1.157v-5.854h-5.96a1.16 1.16 0 1 1 0-2.32h7.117c.638 0 1.156.517 1.156 1.156v7.018c0 .639-.518 1.157-1.156 1.157Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 93445"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIcon);
export default __webpack_public_path__ + "static/media/graph_icon.048a1c8c6d598dac04251a5719957956.svg";
export { ForwardRef as ReactComponent };